export const CONTACT_SUPPORT_REQUEST = 'CONTACT_SUPPORT_REQUEST';
export const CONTACT_SUPPORT_FAILURE = 'CONTACT_SUPPORT_FAILURE';
export const CONTACT_SUPPORT_SUCCESS = 'CONTACT_SUPPORT_SUCCESS';
export const RESET_CONTACT_SUPPORT = 'RESET_CONTACT_SUPPORT';
